import { createClient } from '@supabase/supabase-js'

function resolveConfig() {
  const url =
    process.env.REACT_APP_SUPABASE_URL ||
    process.env.NEXT_PUBLIC_SUPABASE_URL ||
    (typeof window !== 'undefined' ? window.__SUPABASE_URL__ : undefined) ||
    localStorage.getItem('supabase_url')
  const key =
    process.env.REACT_APP_SUPABASE_ANON_KEY ||
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY ||
    process.env.NEXT_PUBLIC_SUPABASE_PUBLISHABLE_DEFAULT_KEY ||
    (typeof window !== 'undefined' ? window.__SUPABASE_ANON_KEY__ : undefined) ||
    localStorage.getItem('supabase_key')
  return { url, key }
}

let client = null

export const supabase = new Proxy({}, {
  get(_, prop) {
    if (!client) {
      const { url, key } = resolveConfig()
      if (!url || !key) {
        console.error('Supabase não configurado. Defina REACT_APP_SUPABASE_URL/REACT_APP_SUPABASE_ANON_KEY ou localStorage supabase_url/supabase_key.')
        throw new Error('Supabase URL/Key ausentes')
      }
      client = createClient(url, key, { auth: { persistSession: true } })
    }
    return client[prop]
  }
})
